/**
 * Created by hernanherreros on 2019-07-21
 */

import * as React from 'react'
import { flowRight } from 'lodash'
import * as Moment from 'moment'
import { extendMoment } from 'moment-range'
import 'moment/locale/es'
import { Trans } from '@lingui/macro'
import styled from 'styled-components'
import { message, Modal, Col, Row } from 'antd'
import withCongress, { ComponentProps } from '../../../providers/Congress/withCongress'
import withWizardProps, { WizardProps } from '../../../wrappers/withWizardParams'
import ActivitiesContext, { ActivitiesContextInterface } from '../components/ActivitiesContext'
import { i18n } from '../../../providers/Locale/localeProvider'
import { getActivities, getInscriptionActivities, saveActivities, updateActivities } from '../requests/activities'
import DetailResolver from '../../../components/Resolvers/DetailResolver'
import ActivitiesCart from '../components/ActivitiesCart'
import ActivitySelector, { Day } from '../components/ActivitySelector'
import { capitalize } from '../../../helpers/general'
import Section from '../../../components/Section/Section'
import Button from '../../../components/Utils/Button'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { sendQRTicket } from '../../../requests/inscription'

const moment = extendMoment(Moment)

interface Props extends ComponentProps, WizardProps, RouteComponentProps {
  onSuccess?: () => void;
  nextLabel: string;
  onExistingActivities: (activities?: any) => void;
  editingSelection: boolean;
  isUpdate?: boolean;
}


class Activities extends React.Component<Props, ActivitiesContextInterface> {
  constructor (props: Props) {
    super(props)

    this.state = {
      selectActivity: (id: number) => this.updateActivitySelection(id),
      removeActivity: (id: number) => this.updateActivitySelection(id, true),
      setActivityAvailability: this.setActivityAvailability,
      isLoading: true,
      selectedActivities: [],
      activities: [],
      isSubmitting: false,
      editingSelection: false,
    }
  }

  resolver: any = React.createRef()

  button: any = React.createRef()

  static defaultProps = {
    onExistingActivities: () => {
    },
    onSuccess: () => {
    },
    editingSelection: false,
  }

  componentWillMount () {
    const { editingSelection } = this.props

    this.setState({ editingSelection })
  }

  handleFormSubmit = () => {
    const { selectedActivities } = this.state

    if (selectedActivities.length === 0) {
      Modal.confirm({
        title: i18n._('No ha seleccionado ninguna actividad'),
        content: i18n._('¿Está seguro/a que desea continuar?'),
        onOk: this.saveActivities,
      })
    } else {
      this.saveActivities()
    }
  }

  saveActivities = () => {
    const { selectedActivities, editingSelection } = this.state
    const { wizard, onSuccess, congress, isUpdate } = this.props

    this.setState({ isSubmitting: true })

    updateActivities(null, {
      Activities: selectedActivities.map(a => ({ ID: a })),
      RegistrationUUID: wizard.token,
      CongressSlug: congress.Slug
    })
      .then(async (resp: any) => {
        onSuccess && onSuccess()
        editingSelection && this.resolver.current.loadData()
        this.button.current && this.button.current.success()
      })
      .catch((resp: any) => {
        alert(resp)
        if (resp.message.indexOf('not available') > -1) {
          Modal.warning({
            width: 500,
            title: i18n._('¡Lo sentimos!'),
            content: i18n._('Una o más actividades seleccionadas ya no poseen cupos. Remueva las actividades sin cupos para continuar'),
          })
        } else {
          message.error(resp.messsage)
        }
      })
      .finally(() => {
        this.setState({ isSubmitting: false })
        if (isUpdate) sendQRTicket({uuid: wizard.token},{})
      })
  }

  getActivity = (id: number) => {
    const { activities } = this.state

    return activities.find((a: any) => a.ID === id) || {}
  }

  updateActivitySelection = (id: number, remove = false) => {
    const { selectedActivities: _selectedActivities } = this.state
    const selectedActivities = [..._selectedActivities]

    const index = selectedActivities.indexOf(id)

    if (remove) {
      if (index > -1) {
        selectedActivities.splice(index, 1)
      }
    } else {
      const isOverlapping = this.isActivityOverlapping(id)

      if (index === -1 && !isOverlapping) {
        selectedActivities.push(id)
      } else if (isOverlapping) {
        Modal.warning({
          width: 500,
          title: i18n._('¡Lo sentimos!'),
          content: i18n._('La actividad seleccionada tiene un tope de horario con otra actividad previamente seleccionada'),
        })
      }
    }

    this.setState({ selectedActivities })
  }

  isActivityOverlapping = (id: number) => {
    const { selectedActivities } = this.state

    const activity = this.getActivity(id)
    const activityDateRange = moment.range(new Date(activity.StartsAt), new Date(activity.EndsAt))

    let isOverlapping = false

    selectedActivities.forEach((id: number) => {
      const selectedActivity = this.getActivity(id)
      const selectedActivityDateRange = moment.range(new Date(selectedActivity.StartsAt), new Date(selectedActivity.EndsAt))

      const overlap = activityDateRange.overlaps(selectedActivityDateRange)

      if (overlap) {
        isOverlapping = true
      }
    })

    return isOverlapping
  }

  setActivityAvailability = (id: number, isAvailable: boolean) => {
    const { activities: _activities } = this.state
    const activities = [..._activities]

    const index = activities.findIndex((a: any) => a.ID === id)

    if (index > -1) {
      activities[index].IsAvailable = isAvailable
      this.setState({ activities })
    }
  }

  isValid = () => {
    const { activities, selectedActivities } = this.state

    let isValid = true

    for (let i = 0; i < selectedActivities.length; i++) {
      const activity = activities.find((a: any) => a.ID === selectedActivities[i])

      if (!activity || !activity.IsAvailable && !activity.FromUserSelection) {
        isValid = false
        break
      }
    }

    return isValid
  }

  handleResolve = (data: any, callback: () => void) => {
    const { onExistingActivities } = this.props

    let selectedActivities: number[] = []
    let activities = data.activities.Data

    if (data.inscriptionActivities.Data && data.inscriptionActivities.Data.length > 0) {
      onExistingActivities && onExistingActivities(data.inscriptionActivities.Data)
      selectedActivities = data.inscriptionActivities.Data.map((a: any) => a.ActivityID)

      selectedActivities.forEach(id => {
        const index = activities.findIndex((a: any) => a.ID === id)
        activities[index].FromUserSelection = true
      })
    }


    this.setState({ activities, selectedActivities, isLoading: false }, callback)
  }

  render () {
    const { congress, wizard } = this.props

    const requestFunction = async () => {
      const activities = await getActivities({ CongressSlug: congress.Slug })
      const inscriptionActivities = await getInscriptionActivities({ id: wizard.token })

      return { activities, inscriptionActivities }
    }

    return (
      <ActivitiesContext.Provider value={this.state}>
        <Text>
          <Trans>Los cupos de las actividades son limitados. Puedes inscribirte a cuantas actividades quieras, siempre y
            cuando no tengan tope de horario.</Trans>
        </Text>

        <Row gutter={32}>
          <Col md={16}>
            <DetailResolver
              ref={this.resolver}
              requestFunction={requestFunction}
              render={this.renderContent}
              onResolve={this.handleResolve}
            />
          </Col>
          <Col md={8}>
            <ActivitiesCart/>
            {this.renderActionButton()}
          </Col>
        </Row>
      </ActivitiesContext.Provider>
    )
  }

  renderContent = (data: any) => {

    return (
      <React.Fragment>
        {this.renderActivitySelector()}
      </React.Fragment>
    )
  }

  renderActivitySelector = () => {
    const { activities: data } = this.state

    const days: string[] = []
    const daysObjects: Day[] = []

    const activities = data.filter((i: any) => i.IsInscribable || i.FromUserSelection)

    for (let i = 0; i < activities.length; i++) {
      const startsAt = activities[i].StartsAt
      const date = moment(startsAt).locale(i18n.language)
      const key = date.toDate().toLocaleDateString()
      const dayName = capitalize(date.format('dddd'))
      const dayNumber = date.date()

      if (days.indexOf(key) === -1) {
        days.push(key)

        daysObjects.push({
          key,
          dayName,
          dayNumber,
          date,
          activities: [activities[i]],
        })
      } else {
        const index = days.indexOf(key)

        daysObjects[index].activities.push(activities[i])
      }
    }

    return (
      <ActivitySelector
        days={daysObjects}
      />
    )
  }

  renderActionButton () {
    const { isSubmitting, isLoading } = this.state
    const { nextLabel } = this.props

    return (
      <ButtonContainer>
        <Button
          slim
          ref={this.button}
          color="#5A87CD"
          disabled={!this.isValid() || isLoading}
          loading={isSubmitting}
          onClick={this.handleFormSubmit}
        >
          {nextLabel}
        </Button>
      </ButtonContainer>
    )
  }
}

const Text = styled.p`
  margin: 30px 0;
  text-align: center;
`

const ButtonContainer = styled.div`
  margin-top: 24px;
  margin-bottom: 50px;

  button {
  }
`


export default flowRight([withCongress, withRouter, withWizardProps])(Activities)
